import { Link } from "react-router-dom";

const columns = [
  {
    title: "浏览",
    links: [
      { label: "首页", to: "/" },
      { label: "话题库", to: "/topics" },
      { label: "本周热榜", to: "/#ranking" },
      { label: "精选话题", to: "/#featured" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容原则", to: "/about#principles" },
      { label: "用户口碑", to: "/about#voices" },
      { label: "联系我们", to: "/about#contact" },
    ],
  },
  {
    title: "帮助",
    links: [
      { label: "常见问题", to: "/faq" },
      { label: "收藏与书签", to: "/faq#使用与收藏" },
      { label: "内容与更新", to: "/faq#内容与更新" },
      { label: "账号与隐私", to: "/faq#账号与隐私" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-xl font-bold">
                5
              </span>
              <span className="font-heading text-2xl font-bold text-background-50">5看料网</span>
            </div>
            <p className="mt-5 text-sm leading-7 text-background-200/85 max-w-md">
              聚合每日网络热点、娱乐动态与话题资讯，帮你用收藏、保存、书签、记录、标记与关注，
              把感兴趣的内容随手存下，随时回看，不错过任何一条重要动态。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="mailto:hello@5kanliao.cn"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-background-50 text-secondary-900 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                <span>hello@5kanliao.cn</span>
              </a>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base font-semibold text-background-50">
                {col.title}
              </h3>
              <ul className="mt-5 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200/85 hover:text-accent-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">
            © 2026 5看料网 · 内容仅供浏览参考，收藏与浏览记录保存在你的本地设备。
          </p>
          <p className="text-xs text-background-200/70 flex items-center gap-2">
            <i className="ri-time-line"></i>
            <span>每日更新 · 热点随时收录</span>
          </p>
        </div>
      </div>
    </footer>
  );
}